<template>
    <a-upload-dragger 
        name="file"
        v-on:change="handleUploadChange"
        :multiple="true"
        :beforeUpload="beforeUpload"
        :remove="handleRemove"
        :fileList="fileList"
    >
        <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
            Kattintson, vagy húzza ide a feltölteni kívánt fájlokat.
        </p>
    </a-upload-dragger>
</template>

<script>

export default {
    props: {
        fileList: Array
    },

    model: {
        prop: 'fileList',
        event: 'fileListChange'
    },

    data() {
        return {
            // fileList: [],
        }
    },

    methods: {
        beforeUpload(file) {
            let newFileList = [...this.fileList, file];
            newFileList = newFileList.map(file => {
                if (!file.hasOwnProperty('nice_name')) {
                    file.nice_name = file.name;
                }
                return file;
            })
            this.emitFileListChange(newFileList);
            return false;
        },

        handleUploadChange(e) {
            this.emitFileListChange(e.fileList);
        },

        handleRemove(file) {
            const ix = this.fileList.indexOf(file);
            const newFileList = [...this.fileList];
            newFileList.splice(ix, 1);

            this.emitFileListChange(newFileList);
            // this.fileList = newFileList;
        },

        emitFileListChange(newFileList) {
            this.$emit('fileListChange', newFileList);
        }
    }
}
</script>

<style>

</style>
